import axios from "axios";
import {
    IP
} from "../index";


// 查询问答配置
export async function selectAnswerConfig() {
    var resp = await axios.post(`${IP}/admin/answerConfig/select`, {

    });
    return resp.data;
}
// 新增问答配置
export async function addAnswerConfig(data) {
    var resp = await axios.post(`${IP}/admin/answerConfig/add`, data);
    return resp.data;
}
// 修改问答配置
export async function updateAnswerConfig(data) {
    var resp = await axios.post(`${IP}/admin/answerConfig/update`,data);
    return resp.data;
}
// 删除问答配置
export async function deleteAnswerConfig(id) {
    var resp = await axios.post(`${IP}/admin/answerConfig/delete`, {
        id
    });
    return resp.data;
}